import React from "react";
import {withRouter} from 'react-router-dom';
import styles from "./NavigationBarMobile.module.scss";

const NavigationBarMobile = props => {
  let pathname = props.pathname ? props.pathname.split('/') : [''];
  pathname = pathname.length > 0 ? pathname[1] : pathname[0];
  let selectedItem = props.items.find(i => {
    const url = i.url ? i.url.split('/') : [''];
    const otherUrl = i.otherUrls ? i.otherUrls.map(url => url.split('/')) : null;
    return url[1] === pathname || (otherUrl && otherUrl.find(url => url[0] === pathname));
  });
  if (!selectedItem) {
    selectedItem = props.items.find(i => i.index === props.default);
  }

  const totalSteps = props.items.filter(i => i.display).length;

  return <div className={styles.menuCont}>
    <div className={`${styles.mobileNavigation} clearfix`}>
      <div className={styles.stepCont}>
        <em>Step {selectedItem ? selectedItem.index : 0} of {totalSteps}</em> -&nbsp;
      </div>
      <div className={styles.stepLabel}>{selectedItem ? selectedItem.plainLabel : ''}</div>
    </div>
  </div>
};

export default withRouter(props => <NavigationBarMobile {...props}/>);
